import React from 'react';
import { Box, Button, Text, VStack, Container } from '@chakra-ui/react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error);
        console.error('Error info:', errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Container maxW="container.lg" py={10}>
                    <VStack spacing={6} align="center">
                        <Box
                            p={8}
                            borderRadius="xl"
                            bg="rgba(255, 0, 0, 0.1)"
                            borderWidth="2px"
                            borderColor="red.500"
                            textAlign="center"
                            w="100%"
                        >
                            <Text fontSize="2xl" fontWeight="bold" color="red.400" mb={4}>
                                Oops! Something went wrong
                            </Text>
                            <Text color="gray.300" mb={6}>
                                {this.state.error?.message || 'An unexpected error occurred'}
                            </Text>
                            <Button
                                colorScheme="red"
                                onClick={this.handleReload}
                                size="lg"
                                _hover={{
                                    transform: 'scale(1.05)',
                                    bg: 'red.600'
                                }}
                            >
                                Reload Page
                            </Button>
                        </Box>
                    </VStack>
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
